import React, { useMemo } from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface HotelItem {
  name: string;
  address: string;
  phone: string;
  priceValue: string; // Hanya angka/nilai harganya
  image: string;
  link: string;
}

const Hotel: React.FC = () => {
  const { t } = useTranslation(['public', 'common']);

  const hotels: HotelItem[] = useMemo(() => [
    {
      name: "SUNRISE AVENTUS HOTEL NUSA DUA",
      address: "188 Jalan Bypass Ngurah Rai Mumbul, Nusa Dua, Kecamatan Kuta Selatan, Nusa Dua, 80361, Indonesia",
      phone: "21 508 51 (469)",
      priceValue: "Rp 400.000",
      image: "/facility/hotel/sunrise-aventus-hote-nusa-dua.jpg",
      link: "https://www.guestreservations.com/sunrise-aventus-hotel-nusa-dua/booking?msclkid=c8809eae952e1b9c6a31f64dc2ad417c",
    },
    {
      name: "JIMBARAN BAY BEACH RESORT & SPA",
      address: "Jl. Pantai Kedonganan 888, Jimbaran Bay, Bali - Indonesia",
      phone: "+62 361 705 999",
      priceValue: "Rp 1.600.000",
      image: "/facility/hotel/jimbaran-bay-beach-resort.jpg",
      link: "https://www.jimbaranbaybeach.com",
    },
    {
      name: "Hilton Garden Inn Ngurah Rai Airport Bali",
      address: "Jalan Airport Ngurah Rai, No. 7 Kuta, Kuta, 80361, Indonesia",
      phone: "21 508 51 (469)",
      priceValue: "Rp 1.300.000",
      image: "/facility/hotel/hilton.jpg",
      link: "https://www.guestreservations.com/hilton-garden-inn-bali-ngurah-rai-airport/booking?msclkid=c604b60a79161287797cdee925d7aa8e",
    },
  ], []);

  return (
    <section id="hotel" className="py-20 bg-gray-50 dark:bg-gray-950">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white tracking-tight">
            {t('public:accommodation.title_main')} <span className="text-green-600">{t('public:accommodation.title_highlight')}</span>
          </h2>
          <div className="mt-2 w-16 h-1 bg-green-600 mx-auto rounded"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {hotels.map((hotel, i) => (
            <div
              key={i}
              className="bg-white dark:bg-gray-900 rounded-2xl shadow-md overflow-hidden hover:shadow-lg transition-all"
            >
              <div className="relative">
                <img
                  src={hotel.image}
                  alt={hotel.name}
                  className="w-full h-60 object-cover"
                />
                <div className="absolute bottom-0 left-0 bg-green-700 text-white text-sm px-4 py-1 rounded-tr-lg">
                  {/* Interpolasi harga secara dinamis */}
                  {t('public:accommodation.price_start', { price: hotel.priceValue })}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-semibold uppercase text-gray-900 dark:text-white mb-2">
                  {hotel.name}
                </h3>
                <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed mb-2">
                  {hotel.address}
                </p>
                <p className="text-gray-700 dark:text-gray-300 text-sm mb-4">{hotel.phone}</p>
                <div className="text-right">
                  <Button
                    asChild
                    variant="link"
                    className="text-red-500 hover:text-red-600 text-sm font-semibold"
                  >
                    <a href={hotel.link} target="_blank" rel="noopener noreferrer">
                      {t('common:buttons.details')}
                    </a>
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hotel;